import { useState } from "react";

const useTouchEvents = (action: () => Promise<void>) => {
  const [isTouching, setIsTouching] = useState(false);
  const [startTouch, setStartTouch] = useState<{ x: number; y: number } | null>(
    null
  );
  const touchThreshold = 10;

  const handleTouchStart = (e: React.TouchEvent) => {
    const touch = e.touches[0];
    setStartTouch({ x: touch.clientX, y: touch.clientY });
    setIsTouching(true);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (!startTouch) return;

    const touch = e.touches[0];
    const dx = Math.abs(touch.clientX - startTouch.x);
    const dy = Math.abs(touch.clientY - startTouch.y);

    if (dx > touchThreshold || dy > touchThreshold) {
      setIsTouching(false);
    }
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    if (isTouching && startTouch) {
      action();
    }
    setStartTouch(null);
    setIsTouching(false);
  };

  return { handleTouchStart, handleTouchMove, handleTouchEnd };
};

export default useTouchEvents;
